<template>
  <FormulateForm v-model="formValues">
    <b-row>
      <b-col md="4" v-for="(field, idx) in fields" :key="idx" class="border">
        <div>
          <FormulateInput v-bind="field"> </FormulateInput>
          <div>
            <pre>{{ JSON.stringify({ value: formValues[field.name] }, null, 2) }}</pre>
          </div>
        </div>
      </b-col>
    </b-row>
  </FormulateForm>
</template>
<script>
export default {
  data() {
    return {
      formValues: {},
      fields: [
        {
          type: 'phone',
          label: 'Phone Number',
          name: 'phoneNum',
        },
      ],
    }
  },
}
</script>
